import React from "react";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import AuthProvider from "./auth/AuthProvider";
import AppRouter from "./routes/AppRouter";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
  shape: {
    borderRadius: 10,
  },
});

const App = () => {
  console.log("Current route:", window.location.pathname); // Verify route matches
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <Router> */}
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
      {/* </Router> */}
    </ThemeProvider>
  );
};

export default App;
